<template>
    <div>

        <!-- loading spinner -->
        <div v-if="loading" id = "blockchain-data-loading">
            <div class="lds-facebook"><div></div><div></div><div></div></div>
            <div>Blockchain (LifeChain Private Network) processing...</div>
        </div>

        <!-- loading error -->
        <div v-if="error" id="blockchain-data-loading-error" style="color: red; text-align: center; margin-top: 225px;">
            <font-awesome-icon icon="fa-solid fa-exclamation-circle" style="font-size: 40px; padding-bottom: 20px;"/>
            <div><b>Error</b> - Unable to connect to Blockchain (test network)</div> <br />
            <!-- {{ errorDetails }} -->
        </div>

        <!-- container -->
        <div v-if="!loading && !error" id="blockchain-container">

            <!-- header -->
            <div id="blockchain-header-container">
                <div id="blockchain-heading">
                    <h4>BioContracts</h4>
                </div>
                <div id="blockchain-button-container">
                    <button id="create-new-contract-button" type="button" @click="openNewContractModal" class="btn btn-primary btn-sm action-button" v-b-modal="'new-contract-modal'">
                        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="plus" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-plus">
                            <path fill="currentColor" d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z" class=""></path>
                        </svg>
                        <span style="padding-left: 10px;">Create New BioContract</span>
                    </button>
                    <br /><br />
                    <a href="http://3.27.199.18:8080" target="_blank">Blockchain Explorer</a>
                </div> 
            </div>

            <!-- tabs -->
            <div style="width: 100%; float: left; padding-top: 30px;">
                <b-tabs content-class="mt-3">
                    <!-- In progress -->
                    <b-tab :title="blockchainInProgressCount" active>
                        <table class="table">
                            <thead>
                                <tr>
                                <th scope="col" style="min-width:130px;">Name</th>                                                                                                                     
                                <th scope="col">Created</th>
                                <th scope="col">Current State</th>
                                <th scope="col">Progress</th>
                                <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="block in blockchainInProgress" v-bind:key="block.ID">
                                        <td style="min-width:130px; vertical-align: top; white-space: nowrap;">  
                                            <a href="#" v-b-modal="'contract-detals-modal'" @click="sendInfo(block, false)">
                                                {{ block.name }} 
                                            </a>
                                        </td>
                                    <td style="vertical-align: top;"> {{ block.TimeStamp }} </td>
                                    <td style="vertical-align: top;"> {{ block.StateText }} </td>
                                    <td class = "chart" Style="width:30%; vertical-align: middle;">
                                        <div class="progress">
                                            <div class="progress-bar progress-bar-contract" role="progressbar" v-bind:style="{ width: block.stateProgress + '%' }" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                                                <div style="text-align:left; padding-left:10px;">
                                                    {{ block.stateProgress }} %
                                                </div>
                                            </div>
                                        </div>
                                    </td> 
                                    <td style="vertical-align: middle;">
                                        <button type="button" @click="blockchainStageComplete(block)" class="btn btn-secondary btn-sm action-button contract-action" style="margin: 0;">Complete Stage</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </b-tab>
                    <!-- Completed -->
                    <b-tab :title="blockchainCompletedCount">
                        <table class="table">
                            <thead>
                                <tr>
                                <!-- <th scope="col">Contract ID</th> -->
                                <th scope="col" style="min-width:130px;">Name</th>
                                <th scope="col">Created</th>
                                <!-- <th scope="col">Current State</th> -->
                                <th scope="col">Progress</th>
                                <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="block in blockchainCompleted" v-bind:key="block.ID">
                                        <td style="min-width:130px;"> 
                                            <a href="#" v-b-modal="'contract-detals-modal'" @click="sendInfo(block, false)">
                                                {{ block.name }} 
                                            </a>
                                        </td>
                                    <!-- <td> {{ block.name }}  </td> -->
                                    <td> {{ block.TimeStamp }} </td>
                                    <!-- <td> {{ block.StateText }} </td> -->
                                    <td class = "chart" Style="width:30%; padding-top: 11px;">
                                        <div class="progress">
                                            <div class="progress-bar progress-bar-contract" role="progressbar" v-bind:style="{ width: '100%' }" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                                                <div style="text-align:left; padding-left:10px;">
                                                    100 %
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </b-tab>
                </b-tabs>
            </div>  

            <!-- New contract modal -->
            <b-modal id="new-contract-modal" size="md" title="Create New BioContract" button-size="sm" @ok="createNewContract">
                <div>
                    <b-form-group id="input-group-2" label="Contract Name:" label-for="input-2">
                        <b-form-input
                        id="input-2"
                        v-model="contractName"
                        placeholder="Enter name for contract"
                        required
                        ></b-form-input>
                    </b-form-group>
                    <b-form-group id="input-group-3" label="Contract Application:" label-for="input-3">
                        <b-form-select
                        id="input-3"
                        v-model="contractApplication"
                        :options="contractApplicationOptions"
                        required
                        ></b-form-select>
                    </b-form-group>
                    <b-form-group id="input-group-3" label="Contract Template:" label-for="input-3">
                        <b-form-select
                        id="input-3"
                        v-model="contractTemplate"
                        :options="contractTemplateOptions"
                        required
                        ></b-form-select>
                    </b-form-group>
                </div>
            </b-modal>

            <!-- contract details modal -->
            <b-modal id="contract-detals-modal" size="lg" title="BioContract Details" ok-only ok-variant="secondary" button-size="sm" ok-title="Close">
                <div id="blockchain-data-loading-modal" style="display: block;">
                    <div class="lds-facebook"><div></div><div></div><div></div></div>
                    <div>Blockchain (LifeChain Private Network) processing...</div>                                                        
                </div>
                <div id="blockchain-modal" style="display: none;">

                    <table class="blockchain-info-table">
                        <tr>
                            <td style="padding-right: 10px;"><b>Contract Name</b></td>
                            <td>{{selectedBlock.name }}</td>
                        </tr>
                        <tr>
                            <td style="padding-right: 10px;"><b>Contract ID</b></td>
                            <td>{{selectedBlock.displayid }}</td>
                        </tr>      
                        <tr>
                            <td style="padding-right: 10px;"><b>Created by</b></td>
                            <td>{{selectedBlock.User }}</td>
                        </tr>   
                        <tr>
                            <td style="padding-right: 10px;"><b>Contract Owner</b></td>
                            <td>{{selectedBlock.Owner }}</td>
                        </tr>     
                        <tr>
                            <td style="padding-right: 10px;"><b>Current State</b></td>
                            <td>{{selectedBlock.StateText }}</td>
                        </tr>                                                                                                                                                                                          
                    </table>

                    <div id="main-chain" class="chain" style="float: left; margin-left: 20px; margin-right: 20px;">

                        <!-- 1 -->
                        <div class="chain-row chain-row-item">
                            <!-- hide top of line -->
                            <div style="position: absolute; top: 1px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>
                            <!-- summary -->
                            <div v-if="selectedBlock.stage1 || selectedBlock.stage0" class="chain-label chain-label-complete">

                                <!-- completed -->
                                <div v-if="selectedBlock.stage1">
                                    <img @click="infoBoxClosed_1 = !infoBoxClosed_1" class="hover contractImage" src="../../assets/images/contractIcons/1.png" />
                                    <div @click="infoBoxClosed_1 = !infoBoxClosed_1" class="hover chain-label-complete">1. Doctor Patient Identification Completed</div>
                                    <div @click="infoBoxClosed_1 = !infoBoxClosed_1" class="hover completedText">{{ selectedBlock.stage1 }}</div>

                                    <!-- info box -->
                                    <i @click="infoBoxClosed_1 = !infoBoxClosed_1" class="hover info_box_icon" v-bind:class="[infoBoxClosed_1 ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>

                                    <div v-if="!infoBoxClosed_1">
                                        <div id="collapse-1" style="float: left; width: 100%">

                                            <!-- 1.1 -->
                                            <div style="height: 110px; position: absolute; left: -11px; top: 105px; width: 160px; background-color: white; border: 3px solid #00ad5b; border-left: 3px solid #fff"></div>
                                            <div style="float: left; width: 100%;">
                                                <div style="width: 33.3%; float: left;">
                                                    <div class="info_boc_l1 info_box" @click="selectedMilestone('1.1 Doctor registered','1-1','Milestone',selectedBlock.stage1)">
                                                        1.1 Doctor registered
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- 1.2 -->
                                            <div style="float: left; width: 100%;">
                                                <div style="width: 33.3%; float: left;">
                                                    <div class="info_boc_l1 info_box" @click="selectedMilestone('1.2 Donor/Patient details creation','1-2','Milestone',selectedBlock.stage1)">
                                                        1.2 Donor/Patient details creation
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                <!-- in progress -->
                                <div v-else>
                                    <div style="position: absolute; bottom: -16px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>
                                    <img @click="infoBoxClosed_1 = !infoBoxClosed_1" class="hover contractImage contractImageInProgress" src="../../assets/images/contractIcons/1.png" />
                                    <div @click="infoBoxClosed_1 = !infoBoxClosed_1" class="hover chain-label-in-progress">1. Doctor Patient Identification Completed</div>
                                    <div @click="infoBoxClosed_1 = !infoBoxClosed_1" class="hover inProgressText">In Progress</div>

                                    <!-- info box -->
                                    <i @click="infoBoxClosed_1 = !infoBoxClosed_1" class="hover info_box_icon" v-bind:class="[infoBoxClosed_1 ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>

                                    <div v-if="!infoBoxClosed_1">
                                        <div id="collapse-1" style="float: left; width: 100%">

                                            <!-- process line -->
                                            <div v-if="process_1_1" style="height: 110px; position: absolute; left: -11px; top: 105px; width: 160px; background-color: white; border: 3px solid #0a58ca; border-left: 3px solid #fff; border-right: 1px dashed grey; border-bottom: 1px solid grey;"></div>
                                            <div v-if="process_1_1" style="height: 44px; position: absolute; left: -11px; top: 214px; width: 160px; background-color: white; border: 3px solid #fff;  border-top: 1px dashed grey; border-left: 1px dashed grey;"></div>
                                            <div v-if="process_1_1" style="height: 62px; position: absolute; left: -11px; top: 46px; width: 160px; background-color: white; border: 3px solid #fff;  border-left: 3px solid #0a58ca; border-bottom: 3px solid #0a58ca;"></div>
                                            
                                            <!-- 1.1 -->
                                            <div style="float: left; width: 100%;">
                                                <div style="width: 33.3%; float: left;">
                                                    
                                                    <div class="info_boc_l1 info_box info_boc_in_progress info_boc_in_progress" v-b-modal="'milestone-modal'" @click="selectedMilestone('1.1 Doctor registered','1-1','Milestone',selectedBlock.stage1, true)">
                                                        1.1 Doctor registered
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- 1.2 -->
                                            <div style="float: left; width: 100%;">
                                                <div style="width: 33.3%; float: left;">
                                                    <div class="info_boc_l1 info_box inactiveProcess" @click="selectedMilestone('1.2 Donor/Patient details creation','1-2','Milestone',selectedBlock.stage1)">
                                                        1.2 Donor/Patient details creation
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div v-else class="chain-label chain-label-disabled">
                                <div style="position: absolute; bottom: -26px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                           
                                <img class="contractImage contractImageNotActioned" src="../../assets/images/contractIcons/1.png" />
                                1. Doctor Patient Identification
                            </div>
                        </div>

                        <!-- 2 -->
                        <div class="chain-row chain-row-item">
                            <!-- summary -->
                            <div v-if="selectedBlock.stage2" class="chain-label chain-label-complete">
                                <img @click="infoBoxClosed_2 = !infoBoxClosed_2" class="hover contractImage" src="../../assets/images/contractIcons/2.png" />
                                <div @click="infoBoxClosed_2 = !infoBoxClosed_2" class="hover chain-label-complete">2. Patient Collection Completed</div>
                                <div @click="infoBoxClosed_2 = !infoBoxClosed_2" class="hover completedText">{{ selectedBlock.stage2 }}</div>

                                <!-- info box -->
                                <i @click="infoBoxClosed_2 = !infoBoxClosed_2" class="hover info_box_icon" v-bind:class="[infoBoxClosed_2 ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>
                                <div v-if="!infoBoxClosed_2">
                                    <div id="collapse-2" style="float: left; width: 100%" class="mt-2">
                                        <div style="height: 225px; position: absolute; left: -11px; top: 103px; width: 160px; background-color: white; border: 3px solid #00ad5b; border-left: 3px solid #fff"></div>
                                        <div style="float: left; width: 100%;">
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_boc_l1 info_box" @click="selectedMilestone('2.1 Identification of biological materia selected','2-1','Milestone',selectedBlock.stage2)">
                                                    2.1 Identification of biological materia selected
                                                </div>
                                            </div>
                                        </div>
                                        <div style="float: left; width: 100%;">
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_boc_l1 info_box" @click="selectedMilestone('2.2 Sample volume identified','2-2','Milestone',selectedBlock.stage2)">
                                                    2.2 Sample volume identified
                                                </div>
                                            </div>
                                        </div>
                                        <div style="float: left; width: 100%;">
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_boc_l1 info_box" @click="selectedMilestone('2.3 The MIoT packaging device informed','2-3','Milestone',selectedBlock.stage2)">
                                                    2.3 The MIoT packaging device informed
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div v-else-if="selectedBlock.stage1" class="chain-label chain-label-complete">
                                <!-- hide bottom of line -->
                                <div style="position: absolute; bottom: -16px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                              
                                <img class="contractImage contractImageInProgress" src="../../assets/images/contractIcons/2.png" />
                                <div class="chain-label-in-progress">2. Patient Collection</div>
                                <div class="inProgressText">In Progress</div>
                            </div>                                                    
                            <div v-else class="chain-label chain-label-disabled">
                                <!-- hide top of line -->
                                <div style="position: absolute; top: -16px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>
                                <!-- hide bottom of line -->
                                <div style="position: absolute; bottom: -26px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                                                                                   
                                <img class="contractImage contractImageNotActioned" src="../../assets/images/contractIcons/2.png" />
                                2. Patient Collection
                            </div>
                        </div>

                        <!-- 3 -->
                        <div class="chain-row chain-row-item">
                            <!-- summary -->
                            <div v-if="selectedBlock.stage3" class="chain-label chain-label-complete">
                                <img @click="infoBoxClosed_3 = !infoBoxClosed_3" class="hover contractImage" src="../../assets/images/contractIcons/3.png" />
                                <div @click="infoBoxClosed_3 = !infoBoxClosed_3" class="hover chain-label-complete">3. Isolation Leukapheresis Completed</div>
                                <div @click="infoBoxClosed_3 = !infoBoxClosed_3" class="hover completedText">{{ selectedBlock.stage3 }}</div>

                                <!-- info box -->
                                <i @click="infoBoxClosed_3 = !infoBoxClosed_3" class="hover info_box_icon" v-bind:class="[infoBoxClosed_3 ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>
                                <div v-if="!infoBoxClosed_3">
                                    <div id="collapse-3" style="float: left; width: 100%" class="mt-2">
                                        <div style="height: 225px; position: absolute; left: -11px; top: 103px; width: 160px; background-color: white; border: 3px solid #00ad5b; border-left: 3px solid #fff;"></div>
                                        <div style="height: 113px; position: absolute; left: 214px; top: 215px; width: 85px; background-color: white; border: 3px solid #fff; border-top: 3px solid #00ad5b;"></div>                                                                
                                        <div style="height: 753px; position: absolute; left: -11px; top: 236px; width: 376px; background-color: white; border: 3px solid #00ad5b; border-left: 3px solid #fff; border-top: 3px solid #fff;"></div>
                                        <div style="height: 113px; position: absolute; left: 438px; top: 436px; width: 85px; background-color: white; border: 3px solid #fff; border-top: 3px solid #00ad5b;"></div>
                                        <div style="height: 113px; position: absolute; left: 474px; top: 436px; width: 85px; background-color: white; border: 3px solid #00ad5b; border-right: 3px solid #fff;"></div>
                                        <div style="float: left; width: 100%;">
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_boc_l1 info_box" @click="selectedMilestone('3.1 Collection','3-1','Milestone',selectedBlock.stage3)">
                                                    3.1 Collection
                                                </div>
                                            </div>
                                        </div>
                                        <div style="float: left; width: 100%;">
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_boc_l1 info_box" @click="selectedMilestone('3.2 Pre-cryopreservation','3-2','Milestone',selectedBlock.stage3)">
                                                    3.2 Pre-cryopreservation
                                                </div>
                                            </div>
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_boc_l2 info_box" @click="selectedMilestone('3.2.1 Pre-cryopreservation processing','3-2-1','Subprocess',selectedBlock.stage3)">
                                                    3.2.1 Pre-cryopreservation processing
                                                </div>
                                            </div>
                                        </div>
                                        <div style="float: left; width: 100%;">
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_box" style="background-color: #fff; border: none;"></div>
                                            </div>
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_boc_l2 info_box" @click="selectedMilestone('3.2.2 Selection of MIoT packaging','3-2-2','Subprocess',selectedBlock.stage3)">
                                                    3.2.2 Selection of MIoT packaging
                                                </div>
                                            </div>
                                        </div>
                                        <div style="float: left; width: 100%;">
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_box" style="background-color: #fff; border: none;"></div>
                                            </div>
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_boc_l2 info_box" @click="selectedMilestone('3.2.3 Monitoring','3-2-3','Subprocess',selectedBlock.stage3)">
                                                    3.2.3 Monitoring
                                                </div>
                                            </div>
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_boc_l3 info_box" @click="selectedMilestone('3.2.3.1 Temprature Monitoring','3-2-3-1','Subprocess',selectedBlock.stage3)">
                                                    3.2.3.1 Temprature Monitoring 
                                                </div>
                                            </div>
                                        </div>
                                        <div style="float: left; width: 100%;">
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_box" style="background-color: #fff; border: none;"></div>
                                            </div>
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_box" style="background-color: #fff; border: none; z-index: -1"></div>
                                            </div>
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_boc_l3 info_box" @click="selectedMilestone('3.2.3.2 Tracking','3-2-3-2','Subprocess',selectedBlock.stage3)">
                                                    3.2.3.2 Tracking
                                                </div>
                                            </div>
                                        </div>
                                        <div style="float: left; width: 100%;">
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_box" style="background-color: #fff; border: none;"></div>
                                            </div>
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_boc_l2 info_box" @click="selectedMilestone('3.2.4 Holding until cryopreservation','3-2-4','Subprocess',selectedBlock.stage3)">
                                                    3.2.4 Holding until cryopreservation
                                                </div>
                                            </div>
                                        </div>
                                        <div style="float: left; width: 100%;">
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_box" style="background-color: #fff; border: none;"></div>
                                            </div>
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_boc_l2 info_box" @click="selectedMilestone('3.2.5 MIoT cryopreservation device informed','3-2-5','Subprocess',selectedBlock.stage3)">
                                                    3.2.5 MIoT cryopreservation device informed
                                                </div>
                                            </div>
                                        </div>
                                        <div style="float: left; width: 100%;">
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_box" style="background-color: #fff; border: none;"></div>
                                            </div>
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_boc_l2 info_box" @click="selectedMilestone('3.2.6 Select racking system and protocol','3-2-6','Subprocess',selectedBlock.stage3)">
                                                    3.2.6 Select racking system and protocol
                                                </div>
                                            </div>
                                        </div>
                                        <div style="float: left; width: 100%;">
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_boc_l2 info_box" style="background-color: #fff; border: none; z-index: -1;"></div>
                                            </div>
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_boc_l2 info_box" @click="selectedMilestone('3.2.7 MIoT smart packaging device will inform other devices','3-2-7','Subprocess',selectedBlock.stage3)">
                                                    3.2.7 MIoT smart packaging device will inform other devices
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div v-else-if="selectedBlock.stage2" class="chain-label chain-label-complete">
                                <!-- hide bottom of line -->
                                <div style="position: absolute; bottom: -16px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                              
                                <img class="contractImage contractImageInProgress" src="../../assets/images/contractIcons/3.png" />
                                <div class="chain-label-in-progress">3. Isolation Leukapheresis</div>
                                <div class="inProgressText">In Progress</div>
                            </div>                                                         
                            <div v-else class="chain-label chain-label-disabled">
                                <!-- hide top of line -->
                                <div style="position: absolute; top: -16px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                        
                                <!-- hide bottom of line -->
                                <div style="position: absolute; bottom: -26px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                           
                                <img class="contractImage contractImageNotActioned" src="../../assets/images/contractIcons/3.png" />
                                3. Isolation Leukapheresis
                            </div>
                        </div>

                        <!-- 4 -->
                        <div class="chain-row chain-row-item">
                            <!-- summary -->
                            <div v-if="selectedBlock.stage4" class="chain-label chain-label-complete">
                                <img @click="infoBoxClosed_4 = !infoBoxClosed_4" class="hover contractImage" src="../../assets/images/contractIcons/4.png" />
                                <div @click="infoBoxClosed_4 = !infoBoxClosed_4" class="hover chain-label-complete">4. Vitrafy Controlled Cryopreservation Completed</div>
                                <div @click="infoBoxClosed_4 = !infoBoxClosed_4" class="hover completedText">{{ selectedBlock.stage4 }} - {{  selectedBlock.TempData }}</div>

                                <!-- info box -->
                                <i @click="infoBoxClosed_4 = !infoBoxClosed_4" class="hover info_box_icon" v-bind:class="[infoBoxClosed_4 ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>
                                <div v-if="!infoBoxClosed_4">
                                    <div id="collapse-4" style="float: left; width: 100%" class="mt-2">
                                        <div style="height: 225px; position: absolute; left: -11px; top: 103px; width: 160px; background-color: white; border: 3px solid #00ad5b; border-left: 3px solid #fff;"></div>
                                        <div style="height: 113px;position: absolute;left: 212px;top: 103px;width: 85px;background-color: white;border-width: 3px;border-style: solid;border-color: rgb(0, 173, 91) rgb(255, 255, 255) rgb(255, 255, 255);border-image: initial;"></div>
                                        <div style="height: 113px;position: absolute;left: 257px;top: 103px;width: 85px;background-color: white;border-width: 3px;border-style: solid;border-color: rgb(0, 173, 91) rgb(255, 255, 255) rgb(0, 173, 91) rgb(0, 173, 91);border-image: initial;"></div>                                                                
                                        <div style="float: left; width: 100%;">
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_boc_l1 info_box" @click="selectedMilestone('4.1 Monitoring','4-1','Milestone',selectedBlock.stage4)">
                                                    4.1 Monitoring
                                                </div>
                                            </div>
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_boc_l2 info_box" @click="selectedMilestone('4.1.1 Cryopreservation Temperature Monitoring','4-1-1','Subprocess',selectedBlock.stage4)">
                                                    4.1.1 Cryopreservation Temperature Monitoring
                                                </div>
                                            </div>
                                        </div>
                                        <div style="float: left; width: 100%;">
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_boc_l2 info_box" style="background-color: #fff; border: none; z-index: -1;"></div>
                                            </div>
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_boc_l2 info_box" @click="selectedMilestone('4.1.2 Protocol and Cost Tracking','4-1-2','Subprocess',selectedBlock.stage4)">
                                                    4.1.2 Protocol and Cost Tracking
                                                </div>
                                            </div>
                                        </div>                                                                
                                        <div style="float: left; width: 100%;">
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_boc_l1 info_box" v-b-modal="'milestone-modal'" @click="selectedMilestone('4.2 Cryopreservation','4-2','Milestone',selectedBlock.stage4)">
                                                    4.2 Cryopreservation 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div v-else-if="selectedBlock.stage3" class="chain-label chain-label-complete">
                                <!-- hide bottom of line -->
                                <div style="position: absolute; bottom: -16px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                              
                                <img class="contractImage contractImageInProgress" src="../../assets/images/contractIcons/4.png" />
                                <div class="chain-label-in-progress">4. Vitrafy Controlled Cryopreservation</div>
                                <div class="inProgressText">In Progress</div>
                            </div>                                                       
                            <div v-else class="chain-label chain-label-disabled">
                                <!-- hide top of line -->
                                <div style="position: absolute; top: -16px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>
                                <!-- hide bottom of line -->
                                <div style="position: absolute; bottom: -26px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                           
                                <img class="contractImage contractImageNotActioned" src="../../assets/images/contractIcons/4.png" />
                                4. Vitrafy Controlled Cryopreservation
                            </div>
                        </div>

                        <!-- 5 -->
                        <div class="chain-row chain-row-item">
                            <div v-if="selectedBlock.stage5" class="chain-label chain-label-complete">
                                <!-- summary -->
                                <img @click="infoBoxClosed_5 = !infoBoxClosed_5" class="hover contractImage" src="../../assets/images/contractIcons/5.png" />
                                <div @click="infoBoxClosed_5 = !infoBoxClosed_5" class="hover chain-label-complete">5. Specialised Logistics Completed</div>
                                <div @click="infoBoxClosed_5 = !infoBoxClosed_5" class="hover completedText">{{ selectedBlock.stage5 }}</div>

                                <!-- info box -->
                                <i @click="infoBoxClosed_5 = !infoBoxClosed_5" class="hover info_box_icon" v-bind:class="[infoBoxClosed_5 ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>
                                <div v-if="!infoBoxClosed_5">
                                    <div id="collapse-5" style="float: left; width: 100%" class="mt-2">
                                        <div style="height: 225px; position: absolute; left: -11px; top: 103px; width: 160px; background-color: white; border: 3px solid #00ad5b; border-left: 3px solid #fff;"></div>
                                        <div style="height: 113px;position: absolute;left: 212px;top: 103px;width: 85px;background-color: white;border-width: 3px;border-style: solid;border-color: rgb(0, 173, 91) rgb(255, 255, 255) rgb(255, 255, 255);border-image: initial;"></div>
                                        <div style="height: 113px;position: absolute;left: 257px;top: 103px;width: 85px;background-color: white;border-width: 3px;border-style: solid;border-color: rgb(0, 173, 91) rgb(255, 255, 255) rgb(0, 173, 91) rgb(0, 173, 91);border-image: initial;"></div>                                                                
                                        <div style="float: left; width: 100%;">
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_boc_l1 info_box" @click="selectedMilestone('5.1 Monitoring','5-1','Milestone',selectedBlock.stage5)">
                                                    5.1 Monitoring
                                                </div>
                                            </div>
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_boc_l2 info_box" @click="selectedMilestone('5.1.1 Temperature Monitoring','5-1-1','Subprocess',selectedBlock.stage5)">
                                                    5.1.1 Temperature Monitoring
                                                </div>
                                            </div>
                                        </div>
                                        <div style="float: left; width: 100%;">
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_box" style="background-color: #fff; border: none; z-index: -1;"></div>
                                            </div>
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_boc_l2 info_box" @click="selectedMilestone('5.1.2 Location Tracking','5-1-2','Subprocess',selectedBlock.stage5)">
                                                    5.1.2 Location Tracking
                                                </div>
                                            </div>
                                        </div>
                                        <div style="float: left; width: 100%;">
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_boc_l1 info_box" @click="selectedMilestone('5.2 Identification of Target destination','5-2','Milestone',selectedBlock.stage5)">
                                                    5.2 Identification of Target destination 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div v-else-if="selectedBlock.stage4" class="chain-label chain-label-complete">
                                <!-- hide bottom of line -->
                                <div style="position: absolute; bottom: -16px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                        
                                <img class="contractImage contractImageInProgress" src="../../assets/images/contractIcons/5.png" />
                                <div class="chain-label-in-progress">5. Specialised Logistics</div>
                                <div class="inProgressText">In Progress</div>
                            </div>                                                         
                            <div v-else class="chain-label chain-label-disabled">
                                <!-- hide top of line -->
                                <div style="position: absolute; top: -16px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                        
                                <!-- hide bottom of line -->
                                <div style="position: absolute; bottom: -26px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                           
                                <img class="contractImage contractImageNotActioned" src="../../assets/images/contractIcons/5.png" />
                                5. Specialised Logistics
                            </div>
                        </div> 

                        <!-- 6 -->
                        <div class="chain-row chain-row-item">
                            <!-- summary -->
                            <div v-if="selectedBlock.stage6" class="chain-label chain-label-complete">
                                <img @click="infoBoxClosed_6 = !infoBoxClosed_6" class="hover contractImage" src="../../assets/images/contractIcons/6.png" />
                                <div @click="infoBoxClosed_6 = !infoBoxClosed_6" class="hover chain-label-complete">6. Vitrafy Controlled Biothaw Completed</div>
                                <div @click="infoBoxClosed_6 = !infoBoxClosed_6" class="hover completedText">{{ selectedBlock.stage6 }}</div>

                                <!-- info box -->
                                <i @click="infoBoxClosed_6 = !infoBoxClosed_6" class="hover info_box_icon" v-bind:class="[infoBoxClosed_6 ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>
                                <div v-if="!infoBoxClosed_6">
                                    <div id="collapse-6" style="float: left; width: 100%" class="mt-2">
                                        <div style="height: 334px; position: absolute; left: -11px; top: 103px; width: 160px; background-color: white; border: 3px solid #00ad5b; border-left: 3px solid #fff;"></div>
                                        <div style="height: 113px;position: absolute;left: 212px;top: 103px;width: 85px;background-color: white;border-width: 3px;border-style: solid;border-color: rgb(0, 173, 91) rgb(255, 255, 255) rgb(255, 255, 255);border-image: initial;"></div>
                                        <div style="height: 113px;position: absolute;left: 257px;top: 103px;width: 85px;background-color: white;border-width: 3px;border-style: solid;border-color: rgb(0, 173, 91) rgb(255, 255, 255) rgb(0, 173, 91) rgb(0, 173, 91);border-image: initial;"></div>                                                                
                                        <div style="float: left; width: 100%;">
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_boc_l1 info_box" @click="selectedMilestone('6.1 Monitoring','6-1','Milestone',selectedBlock.stage6)">
                                                    6.1 Monitoring
                                                </div>
                                            </div>
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_boc_l2 info_box" @click="selectedMilestone('6.1.1 Temperature Monitoring','6-1-1','Subprocess',selectedBlock.stage6)">
                                                    6.1.1 Temperature Monitoring
                                                </div>
                                            </div>
                                        </div>
                                        <div style="float: left; width: 100%;">
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_box" style="background-color: #fff; border: none; z-index: -1;"></div>
                                            </div>
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_boc_l2 info_box" @click="selectedMilestone('6.1.2 Protocol and Cost Tracking','6-1-2','Subprocess',selectedBlock.stage6)">
                                                    6.1.2 Protocol and Cost Tracking
                                                </div>
                                            </div>
                                        </div>
                                        <div style="float: left; width: 100%;">
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_boc_l1 info_box" @click="selectedMilestone('6.2 Protocol Selection','6-2','Milestone',selectedBlock.stage6)">
                                                    6.2 Protocol Selection
                                                </div>
                                            </div>
                                        </div>
                                        <div style="float: left; width: 100%;">
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_boc_l1 info_box" @click="selectedMilestone('6.3 Thawing','6-2','Milestone',selectedBlock.stage6)">
                                                    6.3 Thawing
                                                </div>
                                            </div>
                                        </div>                                                                
                                    </div>
                                </div>

                            </div>
                            <div v-else-if="selectedBlock.stage5" class="chain-label chain-label-complete">
                                <!-- hide bottom of line -->
                                <div style="position: absolute; bottom: -16px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                              
                                <img class="contractImage contractImageInProgress" src="../../assets/images/contractIcons/6.png" />
                                <div class="chain-label-in-progress">6. Vitrafy Controlled Biothaw</div>
                                <div class="inProgressText">In Progress</div>
                            </div>                                                         
                            <div v-else class="chain-label chain-label-disabled">
                                <!-- hide top of line -->
                                <div style="position: absolute; top: -16px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>
                                <!-- hide bottom of line -->
                                <div style="position: absolute; bottom: -26px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                           
                                <img class="contractImage contractImageNotActioned" src="../../assets/images/contractIcons/6.png" />
                                6. Vitrafy Controlled Biothaw
                            </div>
                        </div>  

                        <!-- 7 -->
                        <div class="chain-row chain-row-item">
                            <!-- summary -->
                            <div v-if="selectedBlock.stage7" class="chain-label chain-label-complete">
                                <img @click="infoBoxClosed_7 = !infoBoxClosed_7" class="hover contractImage" src="../../assets/images/contractIcons/7.png" />
                                <div @click="infoBoxClosed_7 = !infoBoxClosed_7" class="hover chain-label-complete">7. Differentiation Transformation Completed</div>
                                <div @click="infoBoxClosed_7 = !infoBoxClosed_7" class="hover completedText">{{ selectedBlock.stage7 }}</div>

                                <!-- info box -->
                                <i @click="infoBoxClosed_7 = !infoBoxClosed_7" class="hover info_box_icon" v-bind:class="[infoBoxClosed_7 ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>
                                <div v-if="!infoBoxClosed_7">
                                    <div id="collapse-7" style="float: left; width: 100%" class="mt-2">
                                        <div style="height: 225px; position: absolute; left: -11px; top: 103px; width: 160px; background-color: white; border: 3px solid #00ad5b; border-left: 3px solid #fff"></div>
                                        <div style="float: left; width: 100%;">
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_boc_l1 info_box" @click="selectedMilestone('7.1 DNA Plasmid Process','7-1','Milestone',selectedBlock.stage7)">
                                                    7.1 DNA Plasmid Process
                                                </div>
                                            </div>
                                        </div>
                                        <div style="float: left; width: 100%;">
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_boc_l1 info_box" @click="selectedMilestone('7.2 T Cell Process','7-2','Milestone',selectedBlock.stage7)">
                                                    7.2 T Cell Process
                                                </div>
                                            </div>
                                        </div>
                                        <div style="float: left; width: 100%;">
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_boc_l1 info_box" @click="selectedMilestone('7.3 MIoT packaging checks','7-3','Milestone',selectedBlock.stage7)">
                                                    7.3 MIoT packaging checks
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div v-else-if="selectedBlock.stage6" class="chain-label chain-label-complete">
                                <!-- hide bottom of line -->
                                <div style="position: absolute; bottom: -16px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                              
                                <img class="contractImage contractImageInProgress" src="../../assets/images/contractIcons/7.png" />
                                <div class="chain-label-in-progress">7. Differentiation Transformation</div>
                                <div class="inProgressText">In Progress</div>
                            </div>
                            <div v-else class="chain-label chain-label-disabled">
                                <!-- hide top of line -->
                                <div style="position: absolute; top: -16px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                        
                                <!-- hide bottom of line -->
                                <div style="position: absolute; bottom: -26px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                           
                                <img class="contractImage contractImageNotActioned" src="../../assets/images/contractIcons/7.png" />
                                7. Differentiation Transformation
                            </div>
                        </div>

                        <!-- 8 -->
                        <div class="chain-row chain-row-item">
                            <!-- summary -->
                            <div v-if="selectedBlock.stage8" class="chain-label chain-label-complete">
                                <img @click="infoBoxClosed_8 = !infoBoxClosed_8" class="hover contractImage" src="../../assets/images/contractIcons/8.png" />
                                <div @click="infoBoxClosed_8 = !infoBoxClosed_8" class="hover chain-label-complete">8. Expansion Completed</div>
                                <div @click="infoBoxClosed_8 = !infoBoxClosed_8" class="hover completedText">{{ selectedBlock.stage8 }}</div>

                                <!-- info box -->
                                <i @click="infoBoxClosed_8 = !infoBoxClosed_8" class="hover info_box_icon" v-bind:class="[infoBoxClosed_8 ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>
                                <div v-if="!infoBoxClosed_8">
                                    <div id="collapse-8" style="float: left; width: 100%" class="mt-2">
                                        <div style="height: 444px; position: absolute; left: -11px; top: 103px; width: 160px; background-color: white; border: 3px solid #00ad5b; border-left: 3px solid #fff"></div>
                                        <div style="float: left; width: 100%;">
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_boc_l1 info_box" @click="selectedMilestone('8.1 Biological material expanded','8-1','Milestone',selectedBlock.stage8)">
                                                    8.1 Biological material expanded
                                                </div>
                                            </div>
                                        </div>
                                        <div style="float: left; width: 100%;">
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_boc_l1 info_box" @click="selectedMilestone('8.2 determine if subsequent cycles are required','8-2','Milestone',selectedBlock.stage8)">
                                                    8.2 determine if subsequent cycles are required
                                                </div>
                                            </div>
                                        </div>
                                        <div style="float: left; width: 100%;">
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_boc_l1 info_box" @click="selectedMilestone('8.3 Holding until cryopreservation','8-3','Milestone',selectedBlock.stage8)">
                                                    8.3 Holding until cryopreservation
                                                </div>
                                            </div>
                                        </div>
                                        <div style="float: left; width: 100%;">
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_boc_l1 info_box" @click="selectedMilestone('8.4 MIoT Cryopreservation device informed','8-4','Milestone',selectedBlock.stage8)">
                                                    8.4 MIoT Cryopreservation device informed
                                                </div>
                                            </div>
                                        </div>
                                        <div style="float: left; width: 100%;">
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_boc_l1 info_box" @click="selectedMilestone('8.5 Select racking system and protocol ','8-5','Milestone',selectedBlock.stage8)">
                                                    8.5 Select racking system and protocol 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div v-else-if="selectedBlock.stage7" class="chain-label chain-label-complete">
                                <!-- hide bottom of line -->
                                <div style="position: absolute; bottom: -16px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                              
                                <img class="contractImage contractImageInProgress" src="../../assets/images/contractIcons/8.png" />
                                <div class="chain-label-in-progress">8. Expansion</div>
                                <div class="inProgressText">In Progress</div>
                            </div>
                            <div v-else class="chain-label chain-label-disabled">
                                <!-- hide top of line -->
                                <div style="position: absolute; top: -16px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                        
                                <!-- hide bottom of line -->
                                <div style="position: absolute; bottom: -26px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                           
                                <img class="contractImage contractImageNotActioned" src="../../assets/images/contractIcons/8.png" />
                                8. Expansion
                            </div>
                        </div>

                        <!-- 9 -->
                        <div class="chain-row chain-row-item">
                            <div v-if="selectedBlock.stage9" class="chain-label chain-label-complete">
                                <!-- summary -->
                                <img @click="infoBoxClosed_9 = !infoBoxClosed_9" class="hover contractImage" src="../../assets/images/contractIcons/9.png" />
                                <div @click="infoBoxClosed_9 = !infoBoxClosed_9" class="hover chain-label-complete">9. Vitrafy Controlled Cryopreservation Completed</div>
                                <div @click="infoBoxClosed_9 = !infoBoxClosed_9" class="hover completedText">{{ selectedBlock.stage9 }}</div>

                                <!-- info box -->
                                <i @click="infoBoxClosed_9 = !infoBoxClosed_9" class="hover info_box_icon" v-bind:class="[infoBoxClosed_9 ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>
                                <div v-if="!infoBoxClosed_9">
                                    <div id="collapse-9" style="float: left; width: 100%" class="mt-2">
                                        <div style="height: 225px; position: absolute; left: -11px; top: 103px; width: 160px; background-color: white; border: 3px solid #00ad5b; border-left: 3px solid #fff;"></div>
                                        <div style="height: 113px;position: absolute;left: 212px;top: 103px;width: 85px;background-color: white;border-width: 3px;border-style: solid;border-color: rgb(0, 173, 91) rgb(255, 255, 255) rgb(255, 255, 255);border-image: initial;"></div>
                                        <div style="height: 113px;position: absolute;left: 257px;top: 103px;width: 85px;background-color: white;border-width: 3px;border-style: solid;border-color: rgb(0, 173, 91) rgb(255, 255, 255) rgb(0, 173, 91) rgb(0, 173, 91);border-image: initial;"></div>                                                                
                                        <div style="float: left; width: 100%;">
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_boc_l1 info_box" @click="selectedMilestone('9.1 Monitoring','9-1','Milestone',selectedBlock.stage9)">
                                                    9.1 Monitoring
                                                </div>
                                            </div>
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_boc_l2 info_box" @click="selectedMilestone('9.1.1 Cryopreservation Temperature Monitoring','9-1-1','Subprocess',selectedBlock.stage9)">
                                                    9.1.1 Cryopreservation Temperature Monitoring
                                                </div>
                                            </div>
                                        </div>
                                        <div style="float: left; width: 100%;">
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_box" style="background-color: #fff; border: none; z-index: -1;"></div>
                                            </div>
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_boc_l2 info_box" @click="selectedMilestone('9.1.2 Protocol and Cost Tracking','9-1-2','Subprocess',selectedBlock.stage9)">
                                                    9.1.2 Protocol and Cost Tracking
                                                </div>
                                            </div>
                                        </div>
                                        <div style="float: left; width: 100%;">
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_boc_l1 info_box" @click="selectedMilestone('9.2 Cryopreservation','9-2','Milestone',selectedBlock.stage9)">
                                                    9.2 Cryopreservation
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div v-else-if="selectedBlock.stage8" class="chain-label chain-label-complete">
                                <!-- hide bottom of line -->
                                <div style="position: absolute; bottom: -16px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                              
                                <img class="contractImage contractImageInProgress" src="../../assets/images/contractIcons/9.png" />
                                <div class="chain-label-in-progress">9. Vitrafy Controlled Cryopreservation</div>
                                <div class="inProgressText">In Progress</div>
                            </div>
                            <div v-else class="chain-label chain-label-disabled">
                                <!-- hide top of line -->
                                <div style="position: absolute; top: -16px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                        
                                <!-- hide bottom of line -->
                                <div style="position: absolute; bottom: -26px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                           
                                <img class="contractImage contractImageNotActioned" src="../../assets/images/contractIcons/9.png" />
                                9. Vitrafy Controlled Cryopreservation
                            </div>
                        </div>

                        <!-- 10 -->
                        <div class="chain-row chain-row-item">
                            <div v-if="selectedBlock.stage10" class="chain-label chain-label-complete">
                                <!-- summary -->
                                <img @click="infoBoxClosed_10 = !infoBoxClosed_10" class="hover contractImage" src="../../assets/images/contractIcons/10.png" />
                                <div @click="infoBoxClosed_10 = !infoBoxClosed_10" class="hover chain-label-complete">10. Specialised Logistics Completed</div>
                                <div @click="infoBoxClosed_10 = !infoBoxClosed_10" class="hover completedText">{{ selectedBlock.stage10 }}</div>

                                <!-- info box -->
                                <i @click="infoBoxClosed_10 = !infoBoxClosed_10" class="hover info_box_icon" v-bind:class="[infoBoxClosed_10 ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>
                                <div v-if="!infoBoxClosed_10">
                                    <div id="collapse-10" style="float: left; width: 100%" class="mt-2">
                                        <div style="height: 225px; position: absolute; left: -11px; top: 103px; width: 160px; background-color: white; border: 3px solid #00ad5b; border-left: 3px solid #fff;"></div>
                                        <div style="height: 113px;position: absolute;left: 212px;top: 103px;width: 85px;background-color: white;border-width: 3px;border-style: solid;border-color: rgb(0, 173, 91) rgb(255, 255, 255) rgb(255, 255, 255);border-image: initial;"></div>
                                        <div style="height: 113px;position: absolute;left: 257px;top: 103px;width: 85px;background-color: white;border-width: 3px;border-style: solid;border-color: rgb(0, 173, 91) rgb(255, 255, 255) rgb(0, 173, 91) rgb(0, 173, 91);border-image: initial;"></div>                                                                
                                        <div style="float: left; width: 100%;">
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_boc_l1 info_box" @click="selectedMilestone('10.1 Monitoring','10-1','Milestone',selectedBlock.stage10)">
                                                    10.1 Monitoring
                                                </div>
                                            </div>
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_boc_l2 info_box" @click="selectedMilestone('10.1.1 Temperature Monitoring','10-1-1','Subprocess',selectedBlock.stage10)">
                                                    10.1.1 Temperature Monitoring
                                                </div>
                                            </div>
                                        </div>
                                        <div style="float: left; width: 100%;">
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_box" style="background-color: #fff; border: none; z-index: -1;"></div>
                                            </div>
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_boc_l2 info_box" @click="selectedMilestone('10.1.2 Location Tracking','10-1-2','Subprocess',selectedBlock.stage10)">
                                                    10.1.2 Location Tracking
                                                </div>
                                            </div>
                                        </div>
                                        <div style="float: left; width: 100%;">
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_boc_l1 info_box" @click="selectedMilestone('10.2 Identification of Target destination','10-2','Milestone',selectedBlock.stage10)">
                                                    10.2 Identification of Target destination
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div v-else-if="selectedBlock.stage9" class="chain-label chain-label-complete">
                                <!-- hide bottom of line -->
                                <div style="position: absolute; bottom: -16px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                              
                                <img class="contractImage contractImageInProgress" src="../../assets/images/contractIcons/10.png" />
                                <div class="chain-label-in-progress">10. Specialised Logistics</div>
                                <div class="inProgressText">In Progress</div>
                            </div>
                            <div v-else class="chain-label chain-label-disabled">
                                <!-- hide top of line -->
                                <div style="position: absolute; top: -16px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                        
                                <!-- hide bottom of line -->
                                <div style="position: absolute; bottom: -26px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                           
                                <img class="contractImage contractImageNotActioned" src="../../assets/images/contractIcons/10.png" />
                                10. Specialised Logistics
                            </div>
                        </div>

                        <!-- 11 -->
                        <div class="chain-row chain-row-item">
                            <div v-if="selectedBlock.stage11" class="chain-label chain-label-complete">
                                <!-- summary -->
                                <img @click="infoBoxClosed_11 = !infoBoxClosed_11" class="hover contractImage" src="../../assets/images/contractIcons/11.png" />
                                <div @click="infoBoxClosed_11 = !infoBoxClosed_11" class="hover chain-label-complete">11. Vitrafy Controlled Biothaw Completed</div>
                                <div @click="infoBoxClosed_11 = !infoBoxClosed_11" class="hover completedText">{{ selectedBlock.stage11 }}</div>

                                <!-- info box -->
                                <i @click="infoBoxClosed_11 = !infoBoxClosed_11" class="hover info_box_icon" v-bind:class="[infoBoxClosed_11 ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>
                                <div v-if="!infoBoxClosed_11">
                                    <div id="collapse-11" style="float: left; width: 100%" class="mt-2">
                                        <div style="height: 334px; position: absolute; left: -11px; top: 103px; width: 160px; background-color: white; border: 3px solid #00ad5b; border-left: 3px solid #fff;"></div>
                                        <div style="height: 113px;position: absolute;left: 212px;top: 103px;width: 85px;background-color: white;border-width: 3px;border-style: solid;border-color: rgb(0, 173, 91) rgb(255, 255, 255) rgb(255, 255, 255);border-image: initial;"></div>
                                        <div style="height: 113px;position: absolute;left: 257px;top: 103px;width: 85px;background-color: white;border-width: 3px;border-style: solid;border-color: rgb(0, 173, 91) rgb(255, 255, 255) rgb(0, 173, 91) rgb(0, 173, 91);border-image: initial;"></div>                                                                
                                        <div style="float: left; width: 100%;">
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_boc_l1 info_box" @click="selectedMilestone('11.1 Monitoring','11-1','Milestone',selectedBlock.stage11)">
                                                    11.1 Monitoring
                                                </div>
                                            </div>
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_boc_l2 info_box" @click="selectedMilestone('11.1.1 Temperature Monitoring','11-1-1','Subprocess',selectedBlock.stage11)">
                                                    11.1.1 Temperature Monitoring
                                                </div>
                                            </div>
                                        </div>
                                        <div style="float: left; width: 100%;">
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_box" style="background-color: #fff; border: none; z-index: -1;"></div>
                                            </div>
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_boc_l2 info_box" @click="selectedMilestone('11.1.2 Protocol and Cost Tracking','11-1-2','Subprocess',selectedBlock.stage11)">
                                                    11.1.2 Protocol and Cost Tracking
                                                </div>
                                            </div>
                                        </div>
                                        <div style="float: left; width: 100%;">
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_boc_l1 info_box" @click="selectedMilestone('11.2 Protocol Selection','11-2','Milestone',selectedBlock.stage11)">
                                                    11.2 Protocol Selection  
                                                </div>
                                            </div>
                                        </div>
                                        <div style="float: left; width: 100%;">
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_boc_l1 info_box" @click="selectedMilestone('11.3 Thawing','11-3','Milestone',selectedBlock.stage11)">
                                                    11.3 Thawing  
                                                </div>
                                            </div>
                                        </div> 
                                    </div>
                                </div>

                            </div>
                            <div v-else-if="selectedBlock.stage10" class="chain-label chain-label-complete">
                                <!-- hide bottom of line -->
                                <div style="position: absolute; bottom: -16px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                              
                                <img class="contractImage contractImageInProgress" src="../../assets/images/contractIcons/11.png" />
                                <div class="chain-label-in-progress">11. Vitrafy Controlled Biothaw</div>
                                <div class="inProgressText">In Progress</div>
                            </div>
                            <div v-else class="chain-label chain-label-disabled">
                                <!-- hide top of line -->
                                <div style="position: absolute; top: -16px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                        
                                <!-- hide bottom of line -->
                                <div style="position: absolute; bottom: -26px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                           
                                <img class="contractImage contractImageNotActioned" src="../../assets/images/contractIcons/11.png" />
                                11. Vitrafy Controlled Biothaw
                            </div>
                        </div>

                        <!-- 12 -->
                        <div class="chain-row chain-row-item">
                            <!-- summary -->
                            <div v-if="selectedBlock.stage12" class="chain-label chain-label-complete">
                                <img @click="infoBoxClosed_12 = !infoBoxClosed_12" class="hover contractImage" src="../../assets/images/contractIcons/12.png" />
                                <div @click="infoBoxClosed_12 = !infoBoxClosed_12" class="hover chain-label-complete">12. Transplant Completed</div>
                                <div @click="infoBoxClosed_12 = !infoBoxClosed_12" class="hover completedText">{{ selectedBlock.stage12 }}</div>

                                <!-- info box -->
                                <i @click="infoBoxClosed_12 = !infoBoxClosed_12" class="hover info_box_icon" v-bind:class="[infoBoxClosed_12 ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>
                                <div v-if="!infoBoxClosed_12">
                                    <div id="collapse-1" style="float: left; width: 100%">
                                        <div style="height: 110px; position: absolute; left: -11px; top: 105px; width: 160px; background-color: white; border: 3px solid #00ad5b; border-left: 3px solid #fff; border-bottom: 3px solid #fff"></div>
                                        <div style="height: 59px;position: absolute;left: -11px;top: 207px;width: 160px;background-color: white;border-width: 3px;border-style: solid;border-color: rgb(0, 173, 91) rgb(0, 173, 91) rgb(255, 255, 255) rgb(255, 255, 255);border-image: initial;border: none;background-color: #fdfdfe;"></div>
                                        <div style="float: left; width: 100%;">
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_boc_l1 info_box" @click="selectedMilestone('12.1 Doctor, Patient & biological material identified','12-1','Milestone',selectedBlock.stage12)">
                                                    12.1 Doctor, Patient & biological material <br />identified
                                                </div>
                                            </div>
                                        </div>
                                        <div style="float: left; width: 100%;">
                                            <div style="width: 33.3%; float: left;">
                                                <div class="info_boc_l1 info_box" @click="selectedMilestone('12.2 Transplant process','12-2','Milestone',selectedBlock.stage12)">
                                                    12.2 Transplant process
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div v-else-if="selectedBlock.stage11" class="chain-label chain-label-complete">
                                <!-- hide bottom of line -->
                                <div style="position: absolute; bottom: -16px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>
                                <img class="contractImage contractImageInProgress" src="../../assets/images/contractIcons/12.png" />
                                <div class="chain-label-in-progress">12. Transplant</div>
                                <div class="inProgressText">In Progress</div>
                            </div>
                            <div v-else class="chain-label chain-label-disabled">
                                <!-- hide top of line -->
                                <div style="position: absolute; top: -16px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>
                                <!-- hide bottom of line -->
                                <div style="position: absolute; bottom: -26px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                           
                                <img class="contractImage contractImageNotActioned" src="../../assets/images/contractIcons/12.png" />
                                12. Transplant
                            </div>
                            <!-- hide bottom of line -->
                            <div style="position: absolute; bottom: -8px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                        
                        </div>                                                

                        <div class="end-of-chain">END OF CHAIN</div>                                              
                    </div>

                </div>
            </b-modal>

            <!-- milestone modal -->
            <b-modal id="milestone-modal" size="xl" v-bind:title="selectedMilestoneText" ok-only ok-variant="secondary" button-size="sm" ok-title="Close">
                <div>
                    <table class="blockchain-info-table">
                        <tr>
                            <td style="padding-right: 10px;"><b>Process Type</b></td>
                            <td>{{ selectedMilestoneType }}</td>
                        </tr>
                        <tr>
                            <td style="padding-right: 10px;"><b>Process ID</b></td>
                            <td>{{selectedBlock.displayid }}-{{ selectedMilestoneID }}</td>
                        </tr>
                        <tr>
                            <td style="padding-right: 10px;"><b>Action Owner</b></td>
                            <td>Authorised User</td>
                        </tr>     
                        <tr>
                            <td style="padding-right: 10px;"><b>Status</b></td>
                            <td v-if="processInProgress" class="milestoneS-status in-progres-status">IN PROGRESS</td>
                            <td v-else class="milestoneS-status">COMPLETED</td>
                        </tr>
                        <tr v-if="!processInProgress">
                            <td style="padding-right: 10px;"><b>Completion Data</b></td>
                            <td>{{ selectedMilestoneTimestamp }}</td>
                        </tr>
                    </table>

                    <div style="float:left; width:100%; margin-bottom: 10px;">
                        <hr />
                        <!-- google map (in progress) -->
                        <div v-if="processInProgress && locationMotSet" style="display: inline-block; width: 50%; padding-right: 20px; float: left;">
                            <BlockchainTrackingBlank ref="BlockchainTrackingBlank"/>
                        </div>

                        <!-- google map (complete) -->
                        <div v-else style="display: inline-block; width: 50%; padding-right: 20px; float: left;">
                            <BlockchainTracking ref="BlockchainTracking"/>
                        </div>

                        <!-- data -->
                        <div style="display: inline-block; width: 50%; padding-left: 20px; float: left;">

                            <!-- sections 1.1 (in progress) -->
                            <div v-if="processInProgress" class="chain infoBoxChain" style="float: left; margin-left: 20px; margin-right: 20px;">
                                <!-- location -->
                                <div class="chain-row chain-row-item">
                                    <!-- summary -->
                                    <div class="chain-label chain-label-complete">
                                        <!-- Icon and heading -->
                                        <img class="hover contractImage infoBoxImage" src="../../assets/images/contractIcons/location.png" />
                                        <div class="hover chain-label-complete infoBoxLabel">Location Information</div>
                                        <!-- <div class="hover completedText">Vitrafy Lab</div> -->

                                        <!-- info box -->
                                        <!-- <i @click="infoBoxClosed_1 = !infoBoxClosed_1" class="hover info_box_icon infoBoxChevron" v-bind:class="[infoBoxClosed_location ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i> -->
                                        <!-- <div v-if="!infoBoxClosed_location"> -->
                                            <div id="collapse-1" class="infoBoxText" style="float: left; width: 100%">
                                                
                                                <!-- form -->
                                                <b-form-group id="input-group-2" label="Description:" label-for="input-2">
                                                    <b-form-input
                                                    id="input-2"
                                                    v-model="process_location_description"
                                                    placeholder="Description of the location"
                                                    required
                                                    ></b-form-input>
                                                </b-form-group>
                                                <b-form-group id="input-group-2" label="Location:" label-for="input-2">
                                                    <b-form-input
                                                    id="input-2"
                                                    style="display: inline-block; width:360px;"
                                                    v-model="process_location"
                                                    placeholder="Start typing address"
                                                    required
                                                    ></b-form-input>
                                                    <b-button v-if="!detectingLocation" variant="primary" class="btn-sm" style="float: right; height: 33.19px; width: 58.42px" @click="detectLocation()">Detect</b-button>
                                                    <b-button v-else variant="primary" class="btn-sm" style="float: right; height: 33.19px; width: 58.42px" disabled><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span></b-button>
                                                </b-form-group>

                                            </div>
                                        <!-- </div> -->
                                    </div>
                                </div>

                                <!-- doctor details -->
                                <div class="chain-row chain-row-item">
                                    <!-- summary -->
                                    <div class="chain-label chain-label-complete">
                                        <!-- Icon and heading -->
                                        <img class="hover contractImage infoBoxImage" src="../../assets/images/contractIcons/doctor.png" />
                                        <div class="hover chain-label-complete infoBoxLabel">Doctor Details</div>

                                            <div id="collapse-1" class="infoBoxText" style="float: left; width: 100%">
                                                
                                                <!-- form -->
                                                <b-form-group id="input-group-2" label="Title:" label-for="input-2">
                                                    <b-form-input
                                                    id="input-2"
                                                    v-model="process_doctor_title"
                                                    placeholder="Enter title"
                                                    required
                                                    ></b-form-input>
                                                </b-form-group>
                                                <b-form-group id="input-group-2" label="Surname:" label-for="input-2">
                                                    <b-form-input
                                                    id="input-2"
                                                    v-model="process_doctor_surname"
                                                    placeholder="Enter surname"
                                                    required
                                                    ></b-form-input>
                                                </b-form-group>
                                                <b-form-group id="input-group-2" label="Firstname:" label-for="input-2">
                                                    <b-form-input
                                                    id="input-2"
                                                    v-model="process_doctor_firstname"
                                                    placeholder="Enter firstname"
                                                    required
                                                    ></b-form-input>
                                                </b-form-group>
                                                <b-form-group id="input-group-2" label="Phone:" label-for="input-2">
                                                    <b-form-input
                                                    id="input-2"
                                                    v-model="process_doctor_phone"
                                                    placeholder="Enter phone number"
                                                    required
                                                    ></b-form-input>
                                                </b-form-group>
                                                <b-form-group id="input-group-2" label="Email:" label-for="input-2">
                                                    <b-form-input
                                                    id="input-2"
                                                    v-model="process_doctor_email"
                                                    placeholder="Enter email address"
                                                    required
                                                    ></b-form-input>
                                                </b-form-group>
                                                <b-form-group id="input-group-2" label="Profession:" label-for="input-2">
                                                    <b-form-input
                                                    id="input-2"
                                                    v-model="process_doctor_profession"
                                                    placeholder="Enter profession"
                                                    required
                                                    ></b-form-input>
                                                </b-form-group>
                                                <b-form-group id="input-group-2" label="Registration number:" label-for="input-2">
                                                    <b-form-input
                                                    id="input-2"
                                                    v-model="process_doctor_reg_number"
                                                    placeholder="Enter registration number"
                                                    required
                                                    ></b-form-input>
                                                </b-form-group>
                                                <b-form-group id="input-group-3" label="Registration status:" label-for="input-3">
                                                    <b-form-select
                                                    id="input-3"
                                                    v-model="process_doctor_reg_status"
                                                    :options="process_doctor_reg_status_options"
                                                    required
                                                    ></b-form-select>
                                                </b-form-group>

                                            </div>
                                        <!-- </div> -->
                                    </div>
                                </div>

                                <div class="chain-row chain-row-item">
                                    <b-button variant="primary" class="btn-sm" style="float: right; height: 33.19px;" v-b-modal="'process-commit-to-blockchain-modal'">Commit to Blockchain</b-button>
                                </div>

                            </div>

                            <!-- sections 4.2 (completed) -->
                            <div v-else class="chain infoBoxChain" style="float: left; margin-left: 20px; margin-right: 20px;">

                                <!-- location -->
                                <div class="chain-row chain-row-item">
                                    <!-- summary -->
                                    <div class="chain-label chain-label-complete">
                                        <!-- Icon and heading -->
                                        <img @click="infoBoxClosed_location = !infoBoxClosed_location" class="hover contractImage infoBoxImage" src="../../assets/images/contractIcons/location.png" />
                                        <div @click="infoBoxClosed_location = !infoBoxClosed_location" class="hover chain-label-complete infoBoxLabel">Location Information</div>
                                        <div @click="infoBoxClosed_location = !infoBoxClosed_location" class="hover completedText">Vitrafy Lab</div>

                                        <!-- info box -->
                                        <i @click="infoBoxClosed_1 = !infoBoxClosed_1" class="hover info_box_icon infoBoxChevron" v-bind:class="[infoBoxClosed_location ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>
                                        <div v-if="!infoBoxClosed_location">
                                            <div id="collapse-1" class="infoBoxText" style="float: left; width: 100%">
                                                <!-- Info here -->

                                                <table class="blockchain-info-table">
                                                    <tr>
                                                        <td style="padding-right: 10px;"><b>Description</b></td>
                                                        <td>Vitrafy Lab</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-right: 10px;"><b>Address</b></td>
                                                        <td>45 Selkirk Drive, Wendouree VIC 3355 Australia</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-right: 10px; vertical-align: top;"><b>Coordinates</b></td>
                                                        <td>latitude: -37.530854124846904<br /> longitude: 143.84331081186326</td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- doctor details -->
                                <div class="chain-row chain-row-item">
                                    <!-- summary -->
                                    <div class="chain-label chain-label-complete">
                                        <!-- Icon and heading -->
                                        <img @click="infoBoxClosed_doctor = !infoBoxClosed_doctor" class="hover contractImage infoBoxImage" src="../../assets/images/contractIcons/doctor.png" />
                                        <div @click="infoBoxClosed_doctor = !infoBoxClosed_doctor" class="hover chain-label-complete infoBoxLabel">Doctor Details</div>
                                        <div @click="infoBoxClosed_doctor = !infoBoxClosed_doctor" class="hover completedText">Dr. Strange</div>

                                        <!-- info box -->
                                        <i @click="infoBoxClosed_doctor = !infoBoxClosed_doctor" class="hover info_box_icon infoBoxChevron" v-bind:class="[infoBoxClosed_doctor ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>
                                        <div v-if="!infoBoxClosed_doctor">
                                            <div id="collapse-1" class="infoBoxText" style="float: left; width: 100%">
                                                
                                                <table class="blockchain-info-table">

                                                    <tr>
                                                        <td style="padding-right: 10px;"><b>Title:</b></td>
                                                        <td>Dr.</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-right: 10px;"><b>Surname</b></td>
                                                        <td>Strange</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-right: 10px;"><b>Firstname:</b></td>
                                                        <td>Stephen</td>
                                                    </tr>                                                                            
                                                    <tr>
                                                        <td style="padding-right: 10px;"><b>Phone:</b></td>
                                                        <td>+61 411 343 442</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-right: 10px;"><b>Email:</b></td>
                                                        <td>stephen.strange@email.com</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-right: 10px;"><b>Profession</b></td>
                                                        <td>Medical Doctor</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-right: 10px;"><b>Registration number:</b></td>
                                                        <td>123456789</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-right: 10px;"><b>Registration status:</b></td>
                                                        <td>Registered</td>
                                                    </tr>
                                                </table>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- patient -->
                                <div class="chain-row chain-row-item">
                                    <!-- summary -->
                                    <div class="chain-label chain-label-complete">
                                        <!-- Icon and heading -->
                                        <img @click="infoBoxClosed_patient = !infoBoxClosed_patient" class="hover contractImage infoBoxImage" src="../../assets/images/contractIcons/user.png" />
                                        <div @click="infoBoxClosed_patient = !infoBoxClosed_patient" class="hover chain-label-complete infoBoxLabel">Patient Details</div>
                                        <div @click="infoBoxClosed_patient = !infoBoxClosed_patient" class="hover completedText">Joe Citizen</div>

                                        <!-- info box -->
                                        <i @click="infoBoxClosed_patient = !infoBoxClosed_patient" class="hover info_box_icon infoBoxChevron" v-bind:class="[infoBoxClosed_patient ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>
                                        <div v-if="!infoBoxClosed_patient">
                                            <div id="collapse-1" class="infoBoxText" style="float: left; width: 100%">
                                                
                                                <table class="blockchain-info-table">
                                                    <tr>
                                                        <td style="padding-right: 10px;"><b>Title:</b></td>
                                                        <td>Mr.</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-right: 10px;"><b>Firstname:</b></td>
                                                        <td>Joe</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-right: 10px;"><b>Surname</b></td>
                                                        <td>Citizen</td>
                                                    </tr>                                                                                                                                                        
                                                    <tr>
                                                        <td style="padding-right: 10px;"><b>DOB:</b></td>
                                                        <td>23/05/1975</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-right: 10px;"><b>Gender:</b></td>
                                                        <td>Male</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-right: 10px;"><b>Address:</b></td>
                                                        <td>5 Selkirk Drive, Wendouree VIC 3355 Australia</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-right: 10px;"><b>Phone:</b></td>
                                                        <td>+61 456 345 345</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-right: 10px;"><b>Email:</b></td>
                                                        <td>joe.citizen@email.com</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-right: 10px;"><b>Medical Info:</b></td>
                                                        <td><a href="#">Click to view details</a></td>
                                                    </tr>
                                                </table>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- process -->
                                <div class="chain-row chain-row-item" style="width: 100%;">
                                    <!-- summary -->
                                    <div class="chain-label chain-label-complete">
                                        <!-- Icon and heading -->
                                        <img @click="infoBoxClosed_process = !infoBoxClosed_process" class="hover contractImage infoBoxImage" src="../../assets/images/contractIcons/process.png" />
                                        <div @click="infoBoxClosed_process = !infoBoxClosed_process" class="hover chain-label-complete infoBoxLabel">Process Details</div>
                                        <div @click="infoBoxClosed_process = !infoBoxClosed_process" class="hover completedText">4.2 Cryopreservation</div>

                                        <!-- info box -->
                                        <i @click="infoBoxClosed_process = !infoBoxClosed_process" class="hover info_box_icon infoBoxChevron" v-bind:class="[infoBoxClosed_process ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>
                                        <div v-if="!infoBoxClosed_process">
                                            <div id="collapse-1" class="infoBoxText" style="float: left; width: 100%">

                                                    <!-- checks -->
                                                    <div class="process_heading">Prerequisite Checks</div>
                                                    <div class="chain-row chain-row-item">
                                                        <!-- summary -->
                                                        <div class="chain-label chain-label-complete">
                                                            <!-- Icon and heading -->
                                                            <img @click="infoBoxClosed_sample_checks = !infoBoxClosed_sample_checks" class="hover contractImage infoBoxImage" src="../../assets/images/contractIcons/checks.png" />
                                                            <div @click="infoBoxClosed_sample_checks = !infoBoxClosed_sample_checks" class="hover chain-label-complete infoBoxLabel">Milestones</div>
                                                            <div @click="infoBoxClosed_sample_checks = !infoBoxClosed_sample_checks" class="hover completedText">3.2.5, 3.2.6, 3.2.7</div>

                                                            <!-- info box -->
                                                            <i @click="infoBoxClosed_sample_checks = !infoBoxClosed_sample_checks" class="hover info_box_icon infoBoxChevron" v-bind:class="[infoBoxClosed_sample_checks ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>
                                                            <div v-if="!infoBoxClosed_sample_checks">
                                                                <div id="collapse-1" class="infoBoxText" style="float: left; width: 100%">
                                                                    

                                                                    <table class="blockchain-info-table">
                                                                        <tr>
                                                                            <td><i class="fa-solid fa-check" style="color: green; padding-right: 10px;"></i> <b>3.2.5 </b> <a href="#">MIoT cryopreservation device informed</a></td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td><i class="fa-solid fa-check" style="color: green; padding-right: 10px;"></i> <b>3.2.6 </b> <a href="#">Racking system and protocol selected</a></td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td><i class="fa-solid fa-check" style="color: green; padding-right: 10px;"></i> <b>3.2.7 </b> <a href="#">MIoT smart packaging device informed other devices</a></td>
                                                                        </tr>
                                                                    </table>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <!-- sample -->
                                                    <div class="process_heading">Pre-Cryopreservation</div>
                                                    <div class="chain-row chain-row-item">
                                                        <!-- summary -->
                                                        <div class="chain-label chain-label-complete">
                                                            <!-- Icon and heading -->
                                                            <img @click="infoBoxClosed_sample = !infoBoxClosed_sample" class="hover contractImage infoBoxImage" src="../../assets/images/contractIcons/sample.png" />
                                                            <div @click="infoBoxClosed_sample = !infoBoxClosed_sample" class="hover chain-label-complete infoBoxLabel">Sample Details</div>
                                                            <div @click="infoBoxClosed_sample = !infoBoxClosed_sample" class="hover completedText">Vitrafy 30mL Smart MIoT EVA Bag</div>

                                                            <!-- info box -->
                                                            <i @click="infoBoxClosed_sample = !infoBoxClosed_sample" class="hover info_box_icon infoBoxChevron" v-bind:class="[infoBoxClosed_sample ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>
                                                            <div v-if="!infoBoxClosed_sample">
                                                                <div id="collapse-1" class="infoBoxText" style="float: left; width: 100%">
                                                                    

                                                                    <table class="blockchain-info-table">
                                                                        <tr>
                                                                            <td style="padding-right: 10px; vertical-align: top;"><b>Sample Description:</b></td>
                                                                            <td style="white-space: break-spaces;">Human peripheral blood, isolated T-cells in 10% DMSO media</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td style="padding-right: 10px;"><b>Sample Volume:</b></td>
                                                                            <td>20mL</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td style="padding-right: 10px;"><b>Package ID:</b></td>
                                                                            <td>12345-67890-12345b</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td style="padding-right: 10px;"><b>Package Type:</b></td>
                                                                            <td>Vitrafy 30mL Smart MIoT EVA Bag</td>
                                                                        </tr>
                                                                        <tr>
                                                                        <td style="padding-right: 10px;"><b>Technical Info:</b></td>
                                                                            <td><a href="#">Click to view details</a></td>
                                                                        </tr>
                                                                    </table>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <!-- device -->
                                                    <div class="process_heading">Cryopreservation </div>
                                                    <div class="chain-row chain-row-item">
                                                        <!-- summary -->
                                                        <div class="chain-label chain-label-complete">
                                                            <!-- Icon and heading -->
                                                            <img @click="infoBoxClosed_device = !infoBoxClosed_device" class="hover contractImage infoBoxImage" src="../../assets/images/contractIcons/device.png" />
                                                            <div @click="infoBoxClosed_device = !infoBoxClosed_device" class="hover chain-label-complete infoBoxLabel">Device Details</div>
                                                            <div @click="infoBoxClosed_device = !infoBoxClosed_device" class="hover completedText">Cryopreservation Apparatus</div>

                                                            <!-- info box -->
                                                            <i @click="infoBoxClosed_device = !infoBoxClosed_device" class="hover info_box_icon infoBoxChevron" v-bind:class="[infoBoxClosed_device ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>
                                                            <div v-if="!infoBoxClosed_device">
                                                                <div id="collapse-1" class="infoBoxText" style="float: left; width: 100%">
                                                                    

                                                                    <table class="blockchain-info-table">
                                                                        <tr>
                                                                            <td style="padding-right: 10px;"><b>Device Name</b></td>
                                                                            <td>Vitrafy-00004</td>
                                                                        </tr>                                                                                                        
                                                                        <tr>
                                                                            <td style="padding-right: 10px;"><b>Device ID:</b></td>
                                                                            <td>12345-76890-54321d</td>
                                                                        </tr>                                                                                                                                                
                                                                        <tr>
                                                                            <td style="padding-right: 10px;"><b>Device Type:</b></td>
                                                                            <td>Cryopreservation Apparatus</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td style="padding-right: 10px;"><b>Protocol</b></td>
                                                                            <td><a href="#">Click to view details</a></td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td style="padding-right: 10px;"><b>Schedule</b></td>
                                                                            <td><a href="#">Click to view details</a></td>
                                                                        </tr>
                                                                    </table>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <!-- reg -->
                                                    <div class="process_heading">Regulatory</div>
                                                    <div class="chain-row chain-row-item">
                                                        <!-- summary -->
                                                        <div class="chain-label chain-label-complete">
                                                            <!-- Icon and heading -->
                                                            <img @click="infoBoxClosed_sample_reg = !infoBoxClosed_sample_reg" class="hover contractImage infoBoxImage" src="../../assets/images/contractIcons/checks.png" />
                                                            <div @click="infoBoxClosed_sample_reg = !infoBoxClosed_sample_reg" class="hover chain-label-complete infoBoxLabel">Regulatory compliance</div>
                                                            <div @click="infoBoxClosed_sample_reg = !infoBoxClosed_sample_reg" class="hover completedText">FDA, TGA, EMA</div>

                                                            <!-- info box -->
                                                            <i @click="infoBoxClosed_sample_reg = !infoBoxClosed_sample_reg" class="hover info_box_icon infoBoxChevron" v-bind:class="[infoBoxClosed_sample_reg ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>
                                                            <div v-if="!infoBoxClosed_sample_reg">
                                                                <div id="collapse-1" class="infoBoxText" style="float: left; width: 100%">
                                                                    

                                                                    <table class="blockchain-info-table">
                                                                        <tr>
                                                                            <td><i class="fa-solid fa-check" style="color: green; padding-right: 10px;"></i> <b>FDA </b> <a href="#">click to view pdf standards</a></td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td><i class="fa-solid fa-check" style="color: green; padding-right: 10px;"></i> <b>TGA </b> <a href="#">click to view pdf standards</a></td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td><i class="fa-solid fa-check" style="color: green; padding-right: 10px;"></i> <b>EMA </b> <a href="#">click to view pdf standards</a></td>
                                                                        </tr>
                                                                    </table>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>  
                    </div>
                </div>
            </b-modal>

            <!-- Commit to blockchain modal -->
            <b-modal id="process-commit-to-blockchain-modal" title="Commit to Blockchain" @ok="processCommitToBlockchain">
                <div>
                    <b-alert show variant="warning"><font-awesome-icon icon="fa-solid fa-exclamation-circle" /><span style="padding-left: 10px;"><b>Warning Alert</b></span><br />This process is irreversible and will add an immutable record for this contract to the blockchain (test-network)</b-alert>
                    Are you sure you want to commit the following data to the blockchain?
                </div>

                <div style="margin-top: 15px">
                    <table class="blockchain-info-table">
                        <tr>
                            <td colspan="2">
                                <b>LOCATION INFORMATION</b>
                            </td>
                        </tr>
                        <tr>
                            <td style="padding-right: 10px;"><b>Description</b></td>
                            <td>{{ process_location_description }}</td>
                        </tr>
                        <tr>
                            <td style="padding-right: 10px;"><b>Address</b></td>
                            <td>{{ process_location }}</td>
                        </tr>
                        <tr>
                            <td>
                                <br />
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                <b>DOCTOR DETAILS</b>
                            </td>
                        </tr>
                        <tr>
                            <td style="padding-right: 10px;"><b>Title</b></td>
                            <td>{{ process_doctor_title }}</td>
                        </tr>
                        <tr>
                            <td style="padding-right: 10px;"><b>Surname</b></td>
                            <td>{{ process_doctor_surname }}</td>
                        </tr>
                        <tr>
                            <td style="padding-right: 10px;"><b>Firstname</b></td>
                            <td>{{ process_doctor_firstname }}</td>
                        </tr>
                        <tr>
                            <td style="padding-right: 10px;"><b>Phone</b></td>
                            <td>{{ process_doctor_phone }}</td>
                        </tr>
                        <tr>
                            <td style="padding-right: 10px;"><b>Email</b></td>
                            <td>{{ process_doctor_email }}</td>
                        </tr>
                        <tr>
                            <td style="padding-right: 10px;"><b>Profession</b></td>
                            <td>{{ process_doctor_profession }}</td>
                        </tr>
                        <tr>
                            <td style="padding-right: 10px;"><b>Registration number</b></td>
                            <td>{{ process_doctor_reg_number }}</td>
                        </tr>
                        <tr>
                            <td style="padding-right: 10px;"><b>Registration status</b></td>
                            <td>{{ process_doctor_reg_status }}</td>
                        </tr>
                    </table> 
                </div>

                <template #modal-footer="{ cancel, ok }">
                    <b-button size="sm" variant="secondary" @click="cancel()">
                        Cancel
                    </b-button>                    
                    <b-button size="sm" variant="warning" @click="ok()">
                        Commit
                    </b-button>
                </template>
            </b-modal>
        </div>

    </div>
</template>

<script>
    import BlockchainTracking from '@/components/BlockchainTracking.vue';
    import BlockchainTrackingBlank from '@/components/BlockchainTrackingBlank.vue';

    export default {
        name: 'blockchainDashboard',
        components: {
            BlockchainTracking,
            BlockchainTrackingBlank
        },
        data: function () {
            return {
                loading: true,
                error: false,
                errorDetails: null,
                blockchain: [],
                blockchainInProgress: [],
                blockchainCompleted: [],
                blockchainTemplates: [],
                blockchainInProgressCount: '',
                contractName: 'new contract',
                contractApplication: null,
                contractApplicationOptions: [{ text: 'Select Application', value: null }, 'CAR-T'],
                contractTemplate: null,
                contractTemplateOptions: [{ text: 'Select Template', value: null }, 'CAR-T Test Template 1'],
                infoBoxClosed_1: true,
                infoBoxClosed_2: true,
                infoBoxClosed_3: true,
                infoBoxClosed_4: true,
                infoBoxClosed_5: true,
                infoBoxClosed_6: true,
                infoBoxClosed_7: true,
                infoBoxClosed_8: true,
                infoBoxClosed_9: true,
                infoBoxClosed_10: true,
                infoBoxClosed_11: true,
                infoBoxClosed_12: true,
                selectedBlock: {TempData: {stages: {}}},
                selectedMilestoneText: null,
                selectedMilestoneID: null,
                selectedMilestoneType: null,
                selectedMilestoneTimestamp: null,
                processInProgress: false,        
                process_1_1: true,
                process_1_2: false,
                infoBoxClosed_location: true,
                infoBoxClosed_patient: true,
                infoBoxClosed_doctor: true,
                infoBoxClosed_sample: true,
                infoBoxClosed_sample_checks: true,
                infoBoxClosed_sample_reg: true,
                infoBoxClosed_device: true,
                infoBoxClosed_process: true,
                locationMotSet: true,
                detectingLocation: false,
                process_location_description: null,
                process_location: null,
                process_doctor_name: null,
                process_doctor_title: null,
                process_doctor_firstname: null,
                process_doctor_surname: null,
                process_doctor_phone: null,
                process_doctor_email: null,
                process_doctor_profession: null,
                process_doctor_reg_number: null,
                process_doctor_reg_status: null,
                process_doctor_reg_status_options: [{ text: 'Select One', value: null }, 'Registered', 'Not registered'],
            };
        },
        props: [],
        watch: {},
        methods: {
            async getBlockchain() {
                this.errorDetails = null;
                this.blockchain = [];
                this.blockchainInProgress = [];
                this.blockchainCompleted = [];
                this.blockchainTemplates= [];

                let headers = {
                    'API-Key': process.env.VUE_APP_BLOCKCHAIN_API_KEY
                };

                try {
                    const response = await this.$http.get(
                        "https://mcaloon.org/GetAllAssets",
                        {headers: headers}
                    );
                    this.blockchain = response.data.body;
                    
                    console.log(this.blockchain);

                    // remove TEST contracts
                    var filteredBlockchain = []
                    for(var z = 0; z < this.blockchain.length; z++) {
                        if(this.blockchain[z].State != "TEST" && this.blockchain[z].State != "TEMPLATE") {
                            filteredBlockchain.push(this.blockchain[z]);
                        }
                    }
                    this.blockchain = filteredBlockchain;

                    // filter blockchain
                    var temp = [];
                    var ts;
                    var tsa;

                    for (var i = 0; i < this.blockchain.length; i++) {
                        ts = new Date(parseInt(this.blockchain[i].TimeStamp));
                        this.blockchain[i].datetime = ts;

                        temp.push(this.blockchain[i])

                        var idt = this.blockchain[i].ID.toString().split(':');
                        this.blockchain[i].displayid = idt[0];
                        this.blockchain[i].TimeStamp = idt[1];
                        this.blockchain[i].TimeStampEpoch = idt[1];
                        this.blockchain[i].name = idt[2];

                        ts = new Date(parseInt(this.blockchain[i].TimeStamp));
                        tsa = ts.toLocaleString('en-AU').toUpperCase();
                        var tsb = ts.toLocaleString('en-us', {  weekday: 'short' }) + ' ' + tsa;
                        this.blockchain[i].TimeStamp = tsb.replace(',', '');                    

                        // create text version of current state
                        if(this.blockchain[i].State == "0") {
                            this.blockchain[i].StateText = "1. Doctor Patient Identification (in progress)";
                            this.blockchain[i].stateProgress = 0;
                        }
                        if(this.blockchain[i].State == "1") {
                            this.blockchain[i].StateText = "2. Patient Collection (in progress)";
                            this.blockchain[i].stateProgress = 8.3;
                        }
                        if(this.blockchain[i].State == "2") {
                            this.blockchain[i].StateText = "3. Isolation Leukapheresis (in progress)";
                            this.blockchain[i].stateProgress = 16.6;
                        }
                        if(this.blockchain[i].State == "3") {
                            this.blockchain[i].StateText = "4. Vitrafy Controlled Cryopreservation (in progress)";
                            this.blockchain[i].stateProgress = 24.9;
                        }        
                        if(this.blockchain[i].State == "4") {
                            this.blockchain[i].StateText = "5. Specialised Logistics (in progress)";
                            this.blockchain[i].SensorData = "21";
                            this.blockchain[i].stateProgress = 33.2;
                        }       
                        if(this.blockchain[i].State == "5") {
                            this.blockchain[i].StateText = "6. Vitrafy Controlled Biothaw (in progress)";
                            this.blockchain[i].stateProgress = 41.5;
                        }
                        if(this.blockchain[i].State == "6") {
                            this.blockchain[i].StateText = "7. Differentiation Transformation (in progress)";
                            this.blockchain[i].stateProgress = 49.8;
                        }
                        if(this.blockchain[i].State == "7") {
                            this.blockchain[i].StateText = "8. Expansion (in progress)";
                            this.blockchain[i].stateProgress = 58.1;
                        }    
                        if(this.blockchain[i].State == "8") {
                            this.blockchain[i].StateText = "9. Vitrafy Controlled Cryopreservation (in progress)";
                            this.blockchain[i].stateProgress = 66.4;
                        }    
                        if(this.blockchain[i].State == "9") {
                            this.blockchain[i].StateText = "10. Specialised Logistics (in progress)";
                            this.blockchain[i].stateProgress = 74.7;
                        }    
                        if(this.blockchain[i].State == "10") {
                            this.blockchain[i].StateText = "11. Vitrafy Controlled Biothaw (in progress)";
                            this.blockchain[i].stateProgress = 83;
                        }    
                        if(this.blockchain[i].State == "11") {
                            this.blockchain[i].StateText = "12. Transplant (in progress)";
                            this.blockchain[i].stateProgress = 91.3;
                        }    
                        if(this.blockchain[i].State == "COMPLETE") {
                            this.blockchain[i].StateText = "Smart Contract Completed";
                            this.blockchain[i].stateProgress = 100;
                        }                                                                                                                                                                            
                    }

                    this.blockchain = temp;

                    // reorder devices by creation time
                    this.blockchain.sort(function(a, b){
                        if(a.TimeStampEpoch > b.TimeStampEpoch) { return -1; }
                        if(a.TimeStampEpoch < b.TimeStampEpoch) { return 1; }
                        return 0;
                    })

                    // split blockchain into "In Progress" and "Completed"
                    for (i = 0; i < this.blockchain.length; i++) {
                        if(this.blockchain[i].State != "template") {
                            //if(this.blockchain[i].State > "11" || this.blockchain[i].Owner == "Vitrafy") {
                            if(this.blockchain[i].State == "COMPLETE" || this.blockchain[i].Owner == "Vitrafy" || this.blockchain[i].Owner == "vitrafy") {

                                // remove some of the test contracts 
                                var hideCOntractList = [
                                    "test 123",
                                    "test",
                                    "test phoebe",
                                    "demo 1",
                                    "Eli test",
                                    "test111",
                                    "Eli Test",
                                    "test 123123123",
                                    "123"
                                ]

                                if(!hideCOntractList.includes(this.blockchain[i].name)) {
                                    this.blockchainCompleted.push(this.blockchain[i]);
                                }
                            } else {
                                this.blockchainInProgress.push(this.blockchain[i]);
                            }
                        } else {
                            //this.blockchain[i].TempData = JSON.stringify(this.blockchain[i].TempData);

                            try {
                                this.blockchain[i].TempData = JSON.parse(this.blockchain[i].TempData);
                            } catch(err) {
                                console.log(err);
                            }

                            this.blockchainTemplates.push(this.blockchain[i]);
                        }
                    }
                    
                    this.blockchainInProgressCount = "In Progress (" + this.blockchainInProgress.length + ")";
                    this.blockchainCompletedCount = "Completed (" + this.blockchainCompleted.length + ")";
                    this.blockchainTemplatesCount = "Templates (" + this.blockchainTemplates.length + ")";

                    console.log("blockchainInProgress = " + this.blockchainInProgress.length);
                    console.log("blockchainCompleted = " + this.blockchainCompleted.length);                

                    this.loading = false;
                } catch (error) {
                    console.log(error);
                    this.loading = false;
                    this.error = true;
                    this.errorDetails = error;
                }            
            },            
            openNewContractModal: function() {
                // clear contractName
                this.contractName = '';
                this.contractApplication = null;
                this.contractTemplate = null;
            },
            createNewContract: function() {
                console.log('create new contract button clicked!');
                console.log('contract name = ' + this.contractName);
                this.CreateAsset();
            },
            async CreateAsset() {
                this.loading = true;
                var blockId = this.$parent.uuidv4();
                var timestamp = new Date().getTime();
                blockId = blockId + ":" + timestamp + ":" + this.contractName;

                var data = {
                    "ID": blockId,
                    "TimeStamp": timestamp,
                    "State": "0",
                    "Owner": "Vitrafy (version 2)",
                    "User": this.$parent.userInfo.username,
                    "TempData": ""
                };

                data = JSON.stringify(data);

                let headers = {
                    'Content-Type': 'application/json;charset=utf-8',
                    'API-Key': process.env.VUE_APP_BLOCKCHAIN_API_KEY
                };

                try {
                    const response = await this.$http.post(
                        "https://mcaloon.org/CreateAsset",
                        data,
                        {headers: headers}
                    );
                    this.blockchain = response.data;
                    
                    console.log(this.blockchain);
                    this.getBlockchain();

                } catch (error) {
                    console.log(error);
                }            
            },
            blockchainStageComplete: async function(block) {
                // hide table show loading spinner 
                this.loading = true;

                console.log('blockchainStageComplete button clicked!');  
                var timestamp = new Date().getTime();

                // get latest sensor data
                console.log("waiting for sensor data");
                var latestSensorData = await this.$parent.getLatestSensorData();
                latestSensorData = latestSensorData.split(" ");
                latestSensorData = latestSensorData[0] + " " + latestSensorData[1] + "C " + latestSensorData[2] + "%";
                console.log("SENSOR DATA received [OK]");
                console.log("latestSensorData = " + latestSensorData);
                console.log("writting to blockchain");

                var newState = parseInt(block.State) + 1;

                if(newState == 12) {
                    newState = "COMPLETE";
                }

                var data = {
                    "ID": block.ID,
                    "TimeStamp": timestamp,
                    "State": newState,
                    "Owner": block.Owner,
                    "User": block.User,
                    "TempData": latestSensorData
                };

                console.log(data)            

                data = JSON.stringify(data);

                let headers = {
                    'Content-Type': 'application/json;charset=utf-8',
                    'API-Key': process.env.VUE_APP_BLOCKCHAIN_API_KEY
                };               

                try {
                    const response = await this.$http.post(
                        "https://mcaloon.org/UpdateAsset",
                        data,
                        {headers: headers}
                    );
                    this.blockchain = response.data;
                    
                    console.log(this.blockchain);
                    this.getBlockchain();
                } catch (error) {
                    console.log(error);
                }      
            },
            async sendInfo(block, designerModal) {
                console.log("Inside sendinfo block")
                console.log("block = " + block.ID);

                // reset info boxes
                this.infoBoxClosed_1 = true;
                this.infoBoxClosed_2 = true;
                this.infoBoxClosed_3 = true;
                this.infoBoxClosed_4 = true;
                this.infoBoxClosed_5 = true;
                this.infoBoxClosed_6 = true;
                this.infoBoxClosed_7 = true;
                this.infoBoxClosed_8 = true;
                this.infoBoxClosed_9 = true;
                this.infoBoxClosed_10 = true;
                this.infoBoxClosed_11 = true;
                this.infoBoxClosed_12 = true;

                await this.ReadAssetHistory(block);
                
                this.selectedBlock = block;

                // block history
                console.log(block.history);

                document.getElementById("blockchain-data-loading-modal").style.display = 'none';
                document.getElementById("blockchain-modal").style.display = 'block';

                if(designerModal) {
                    console.log("designer modal opened");
                    this.designermodalOpen = true;
                    console.log(this.selectedBlock.TempData);

                    var data = this.selectedBlock.TempData;

                    console.log("data = ");
                    console.log(data.uuid);
                    console.log(data.stages[0].stageType);

                    //this.selectedBlock.design = JSON.parse(this.selectedBlock.TempData);
                    //console.log(this.selectedBlock.design);
                } else {
                    console.log("block modal opened and NOT designer modal");
                }

            },
            async ReadAssetHistory(block) {
                var data = {
                    "ID": block.ID,
                };

                data = JSON.stringify(data);

                let headers = {
                    'Content-Type': 'application/json;charset=utf-8',
                    'API-Key': process.env.VUE_APP_BLOCKCHAIN_API_KEY
                };

                const ReadAssetHistoryURL = "https://mcaloon.org/ReadAssetHistory";

                try {
                    const response = await this.$http.post(
                        ReadAssetHistoryURL,
                        data,
                        {headers: headers}
                    );                

                    // append history to block
                    block.history = response.data;

                    for (var x = 0; x < response.data.length; x++) {
                        if(response.data[x].State == "0") {    
                            block.stage0 = this.convertBlockTimestamp(response.data[x].TimeStamp);
                        }
                        if(response.data[x].State == "1") {    
                            block.stage1 = this.convertBlockTimestamp(response.data[x].TimeStamp);
                        }
                        if(response.data[x].State == "2") {
                            block.stage2 = this.convertBlockTimestamp(response.data[x].TimeStamp);
                        }
                        if(response.data[x].State == "3") {
                            block.stage3 = this.convertBlockTimestamp(response.data[x].TimeStamp);
                        }
                        if(response.data[x].State == "4") {
                            block.stage4 = this.convertBlockTimestamp(response.data[x].TimeStamp);
                        }
                        if(response.data[x].State == "5") {
                            block.stage5 = this.convertBlockTimestamp(response.data[x].TimeStamp);
                        }
                        if(response.data[x].State == "6") {
                            block.stage6 = this.convertBlockTimestamp(response.data[x].TimeStamp);
                        }
                        if(response.data[x].State == "7") {
                            block.stage7 = this.convertBlockTimestamp(response.data[x].TimeStamp);
                        }
                        if(response.data[x].State == "8") {
                            block.stage8 = this.convertBlockTimestamp(response.data[x].TimeStamp);
                        }
                        if(response.data[x].State == "9") {
                            block.stage9 = this.convertBlockTimestamp(response.data[x].TimeStamp);
                        }
                        if(response.data[x].State == "10") {
                            block.stage10 = this.convertBlockTimestamp(response.data[x].TimeStamp);
                        }
                        if(response.data[x].State == "11") {
                            block.stage11 = this.convertBlockTimestamp(response.data[x].TimeStamp);
                        }
                        if(response.data[x].State == "COMPLETE") {
                            block.stage12 = this.convertBlockTimestamp(response.data[x].TimeStamp);
                        }                        
                    }
                } catch (error) {
                    console.log(error);
                }    
            },
            convertBlockTimestamp: function(timestamp) {
                var ts = new Date(parseInt(timestamp));     
                var tsa = ts.toLocaleString('en-AU').toUpperCase();
                var tsb = ts.toLocaleString('en-us', {  weekday: 'short' }) + ' ' + tsa;
                ts = tsb.replace(',', '');
                return ts;
            },
            selectedMilestone(milstoneText, milestoneID, milestoneType, milestoneTimestamp, inprogress) {
                // reset input fields
                this.locationMotSet = true;
                this.detectingLocation = false,
                this.process_location_description = null;
                this.process_location = null;
                this.process_doctor_name = null;
                this.process_doctor_title = null;
                this.process_doctor_surname = null;
                this.process_doctor_firstname = null;
                this.process_doctor_phone = null;
                this.process_doctor_email = null;
                this.process_doctor_profession = null;
                this.process_doctor_reg_number = null;
                this.process_doctor_reg_status = null;
                
                // check if process is in progress
                if(inprogress) {
                    this.processInProgress = true;
                } else {
                    this.processInProgress = false;
                }
                
                // close any expanded dropdowns
                this.infoBoxClosed_location = true;
                this.infoBoxClosed_patient = true;
                this.infoBoxClosed_doctor = true;
                this.infoBoxClosed_sample = true;
                this.infoBoxClosed_sample_checks = true;
                this.infoBoxClosed_sample_reg = true;
                this.infoBoxClosed_device = true;
                this.infoBoxClosed_process = true;

                // load selected data into modal
                this.selectedMilestoneText = milstoneText;
                this.selectedMilestoneID = milestoneID;
                this.selectedMilestoneType = "Subprocess"; // overriddden
                this.selectedMilestoneTimestamp = milestoneTimestamp;
            },
            detectLocation() {
                console.log("detectLocation clicked");
                this.detectingLocation = true;  

                setTimeout(() => {
                    this.detectingLocation = false;    
                    this.locationMotSet = false;
                    this.process_location = "45 Selkirk Drive, Wendouree VIC 3355 Australia"                    
                }, 1000);
            },
            processCommitToBlockchain() {
                console.log("processCommitToBlockchain clicked");
            },
        },
        mounted: function () {
            this.getBlockchain();
        }
    }
</script>

<style scoped>
    #blockchain-container {
        overflow-y: auto; 
        overflow-x: auto;
    }

    #blockchain-header-container {
        float: left; 
        width: 100%; 
        margin-bottom: 10px;
    }

    #blockchain-heading {
        float: left;        
    }

    #blockchain-button-container {
        float: right;
    }

    .end-of-chain, .modal-footer {
    background-color: #fff;
    z-index: 99;
    }
</style>    
